import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import loadable from '@loadable/component';
import { listingPropTypes } from '../../utils/commonPropTypes';
import messages from '../../utils/translationMessages';
import { Ad } from '@dmm/react-common-components';
import { MediaCarouselModal } from '@dmm/lib-react-ui-components';
import get from 'lodash/get';
import { getConfig } from '../../config/portal';
import './styles.css';
import './styles.desktop.css';
import { isBoatDetailsPageRedesign } from '../../utils/newBDPHelper';
import { PortalConfigContext } from '../../config/portal';

const CarouselDisplayerDesktop = loadable(() =>
  import('../CarouselDisplayer/CarouselDisplayer.desktop.js')
);
const CarouselModalHeader = loadable(() => import('../CarouselModalHeader'));

const Modal = ({ handleClose, show, children, formatMessage }) => {
  const context = useContext(PortalConfigContext);
  if (isBoatDetailsPageRedesign(context)) {
    const handleCloseModal = () => {
      handleClose();
    };

    return (
      <MediaCarouselModal
        open={show}
        onClose={handleCloseModal}
        showCloseText={true}
        closeText={formatMessage(messages.carouselModal.close)}
      >
        <div
          className={classnames(
            'modal-desktop',
            { 'modal display-block modal-carousel': show },
            { 'modal display-none': !show }
          )}
        >
          <section className="modal-main-carousel full-screen">
            {children}
          </section>
        </div>
      </MediaCarouselModal>
    );
  }

  return (
    <div
      className={classnames(
        'modal-desktop',
        { 'modal display-block modal-carousel': show },
        { 'modal display-none': !show }
      )}
    >
      <section className="modal-main-carousel full-screen">
        <button className="close-carousel-modal" onClick={handleClose}>
          <span>{formatMessage(messages.carouselModal.close)}</span>
          <div className="close-carousel-modal-icon" />
        </button>
        {children}
      </section>
    </div>
  );
};

Modal.propTypes = {
  /** The object of the transladeable lenguages */
  formatMessage: PropTypes.func.isRequired,
  /** function that will be called on close modal */
  handleClose: PropTypes.func,
  /** show modal book */
  show: PropTypes.bool,
  /** element that will be showed in the midel of the modal */
  children: PropTypes.element
};

export const CarouselModalDesktop = ({
  device,
  isLoading,
  listing,
  selectedCarouselItem,
  adParams,
  adReload,
  show,
  hideModal,
  intl: { formatMessage, locale },
  isManufacturer,
  onCarouselContactButton
}) => {
  const config = getConfig();

  const currencyCode = get(config, `languages.${locale}.currency.abbr`, null);

  const customPricingOptions = {
    currency: get(config, `supportedCurrencies.${currencyCode}`, undefined),
    formatingOptions: get(
      config,
      `languages.${locale}.currency.format`,
      undefined
    )
  };

  return (
    <Modal show={show} handleClose={hideModal} formatMessage={formatMessage}>
      <>
        {show && (
          <>
            <div className="carousel-ad-container">
              <Ad
                {...adParams.leaderboardModalParams}
                reloadAd={adReload}
                targeting={{ refresh: adReload.toString() }}
              />
            </div>
            <CarouselDisplayerDesktop
              isModal={true}
              device={device}
              isLoading={isLoading}
              listing={listing}
              selectedItem={selectedCarouselItem}
              adParams={adParams}
              adReload={adReload}
            />
            <CarouselModalHeader
              lightStyle
              listing={listing}
              isLoading={isLoading}
              device={device}
              customPricingOptions={customPricingOptions}
              isManufacturer={isManufacturer}
              onCarouselContactButton={onCarouselContactButton}
            />
          </>
        )}
      </>
    </Modal>
  );
};

CarouselModalDesktop.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }).isRequired,
  /** The kind of device: mobile, tablet, desktop */
  device: PropTypes.string,
  /** Defines if the component data is loading */
  isLoading: PropTypes.bool,
  /** The listing of data */
  listing: listingPropTypes,
  url: PropTypes.string,
  /** the selected item in the carousel */
  selectedCarouselItem: PropTypes.number,
  adParams: PropTypes.object,
  adReload: PropTypes.number,
  /** show modal */
  show: PropTypes.bool,
  /** function that will be called when the modal is closed */
  hideModal: PropTypes.func,
  isManufacturer: PropTypes.bool,
  onCarouselContactButton: PropTypes.func
};
